import { render, staticRenderFns } from "./VehicleBulbListItem.vue?vue&type=template&id=6c692ada&scoped=true"
import script from "./VehicleBulbListItem.vue?vue&type=script&lang=js"
export * from "./VehicleBulbListItem.vue?vue&type=script&lang=js"
import style0 from "./VehicleBulbListItem.vue?vue&type=style&index=0&id=6c692ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c692ada",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VehicleBulbBadge: require('/app/components/VehicleBulbBadge.vue').default,ColorTemperatureSwatch: require('/app/components/ColorTemperatureSwatch.vue').default,CommercialOperationBadge: require('/app/components/CommercialOperationBadge.vue').default})
